import React from 'react';
import PropTypes from 'prop-types';

import styles from './ParticipatingClubsSummary.module.css';

// The "Participating Clubs" summary shown atop BOTH the admin Meet Registrations roster and the private
// "My Registrations" self-service page. Pure presentational so the two surfaces render identically — each
// caller normalises its own data source into `clubs: [{ name, count, isHost }]` (no PII, just club + headcount).
const ParticipatingClubsSummary = ({ clubs, totalClubs = 0, totalAthletes = 0 }) => {
  return (
    <>
      <div className={styles.clubsHeader}>
        <h3 className={styles.clubsTitle}>Participating Clubs</h3>
        <span className={styles.clubsTotal}>
          {totalClubs} club{totalClubs === 1 ? '' : 's'} • {totalAthletes} total athlete
          {totalAthletes === 1 ? '' : 's'}
        </span>
      </div>
      <div className={styles.clubsGrid}>
        {clubs.map((club, index) => (
          <div
            key={index}
            className={`${styles.clubCard} ${club.isHost ? styles.hostClubCard : ''}`}
          >
            <div className={styles.clubName}>{club.name}</div>
            <div className={styles.clubCount}>
              {club.count} athlete{club.count === 1 ? '' : 's'}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

ParticipatingClubsSummary.propTypes = {
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
      isHost: PropTypes.bool,
    })
  ).isRequired,
  totalClubs: PropTypes.number,
  totalAthletes: PropTypes.number,
};

export default ParticipatingClubsSummary;
